import api from '../../plugins/api';

const getDealCard = (params) => {
  return api.get('/api/crm/deals/getDealCard', params);
};

export default getDealCard;
